import React, { Component }  from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/app';

import Loginform from '../forms/loginform.jsx';
import Registerform from '../forms/registerform.jsx';
import Activateform from '../forms/activateform.jsx';

class login extends Component {
  componentWillMount(){
    if(!localStorage.appData){
      this.props.changeLoginStatus(0)
    }
  }
  render() {
    return (
      <div className="login-limiter">
        <div className="container-login100">
          <div className="wrap-login100">
            <div className="login100-form validate-form">
              <h1>نرم افزار مدیریت زمان هنگام</h1>
              { this.props.app.login_status === 0 ? <Loginform changeStatus={this.props.changeLoginStatus} setPhone={this.props.addPhoneNumber} /> : null }
              { this.props.app.login_status === 1 ? <Registerform changeStatus={this.props.changeLoginStatus} phone={this.props.app.phone_number} /> : null }
              { this.props.app.login_status === 2 ? <Activateform changeStatus={this.props.changeLoginStatus} phone={this.props.app.phone_number} /> : null }
            </div>
            <div className="login100-more"></div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(login);